import { render } from "./Cats.vue?vue&type=template&id=81a5a9fa"
import script from "./Cats.vue?vue&type=script&lang=js"
export * from "./Cats.vue?vue&type=script&lang=js"

import "./Cats.vue?vue&type=style&index=0&id=81a5a9fa&lang=css"

import exportComponent from "/Volumes/LACIE/vueSites/yem/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__